import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";
import utility from "@app/lib/utility";

import { RATE_LIST, PieRateTotal, PieRateList, ClassList } from "./Components/tomonote";

const ratesBase = RATE_LIST.map((r) => ({ rate: r.RATE, count: 0 }));
const StatOldTomonote = ({}) => {
    const [loadingData, setLoadingData] = useState(true);
    const loginBranchInfo = utility.getLoginBranchInfo();
    const [branches, setBranches] = useState(false);
    const [selectedBranch, setBranch] = useState(loginBranchInfo ? loginBranchInfo : null);
    const [rateLoginTotal, setRateLoginTotal] = useState(null);
    const [rateLogin, setRateLogin] = useState(null);
    const [rateDown, setRateDown] = useState(null);
    const [ratePlay, setRatePlay] = useState(null);
    const [dataAll, setDataAll] = useState(false);
    const [data, setData] = useState(false);
    const classListRef = useRef();
    useEffect(() => {
        if (!branches && !loginBranchInfo) {
            commonData.getBranchList(axios, (err, list) => {
                if (!err) {
                    setBranches(list);
                    getData();
                } else {
                    toast.err(err);
                }
            });
        } else {
            getData();
        }
        return () => {};
    }, []);

    const getData = () => {
        const branchId = loginBranchInfo ? loginBranchInfo.id : 0;
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/stat_old/tomonote/${branchId}`,
        })
            .then((res) => {
                const result = res.data;
                const _data = { ...data };
                _data.list = result.list || [];
                _data.total = result.list && result.list.length > 0 ? result.list.length : 0;
                setDataAll(_data);
                filterData(_data.list, selectedBranch, true);
                filterData(_data.list, selectedBranch);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const onSelectBranch = (e) => {
        const { value } = e.target;
        if (value == 0) {
            setBranch(null);
        } else {
            const selected = branches.find((b) => b.id == value);
            setBranch(selected);
        }
    };

    useEffect(() => {
        if (!selectedBranch) {
            filterData(dataAll.list, null, true);
        } else {
            filterData(dataAll.list, selectedBranch);
        }
        return () => {};
    }, [selectedBranch]);

    const onClickRate = (type, rate) => {
        if (classListRef && classListRef.current) {
            classListRef.current.setSearchParam(type, rate);
        }
    };

    const filterData = (list, selectedBranch, isTotal = false) => {
        let newData = [];
        if (!selectedBranch || isTotal) {
            newData = list ? list : [];
        } else {
            if (list) {
                list.forEach((d) => {
                    if (d.branchId == selectedBranch.id) {
                        newData.push(d);
                    }
                });
            }
        }
        const _rates = {
            login: RATE_LIST.map((r) => ({ rate: r.RATE, count: 0 })),
            down: RATE_LIST.map((r) => ({ rate: r.RATE, count: 0 })),
            play: RATE_LIST.map((r) => ({ rate: r.RATE, count: 0 })),
        };
        if (newData && newData.length > 0) {
            newData.forEach((s) => {
                Object.keys(_rates).forEach((k) => {
                    const rate = _rates[k].find((r) => {
                        if (selectedBranch && !isTotal) {
                            return s[`branchId`] == selectedBranch.id && r.rate == s[`${k}Rate`];
                        }
                        return r.rate == s[`${k}Rate`];
                    });
                    if (rate) {
                        rate.count += 1;
                    }
                });
            });
        }
        if (isTotal) {
            setData({ total: newData.length, list: newData });
            setRateLoginTotal(_rates.login);
            setRateLogin([..._rates.login]);
            setRateDown(_rates.down);
            setRatePlay(_rates.play);
        } else {
            setData({ total: newData.length, list: newData });
            setRateLogin(_rates.login);
            setRateDown(_rates.down);
            setRatePlay(_rates.play);
        }
    };

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">(구) 토모노트 통계 {!loginBranchInfo && selectedBranch ? ` - ${selectedBranch.name}` : ""}</h2>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"></div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                            {branches && (
                                <select name="branch_id" value={selectedBranch ? selectedBranch.id : 0} className="form-control" onChange={onSelectBranch}>
                                    <option key="branchOption_0" value="0">
                                        전체
                                    </option>
                                    {branches.map((branch) => {
                                        return (
                                            <option key={"branchOption_" + branch.id} value={branch.id}>
                                                {branch.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="card">
                                <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="card-header-title">토모노트 접속 현황</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className={selectedBranch ? "col-6" : "col"}>
                                            <PieRateTotal height={220} isTotal={true} rateTotal={rateLoginTotal} />
                                        </div>
                                        {selectedBranch && (
                                            <div className="col-6">
                                                <PieRateTotal height={220} isTotal={false} rateTotal={rateLogin} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <PieRateList height={100} type="login" rateList={rateLogin} onClick={onClickRate} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="row">
                                <div className="col">
                                    <div className="card mb-4">
                                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                                            <div className="row">
                                                <div className="col">
                                                    <h4 className="card-header-title">콘텐츠 다운로드 현황</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col">
                                                    <PieRateList height={100} type="down" rateList={rateDown} onClick={onClickRate} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                                            <div className="row">
                                                <div className="col">
                                                    <h4 className="card-header-title">콘텐츠 실행 현황</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col">
                                                    <PieRateList height={120} type="play" rateList={ratePlay} onClick={onClickRate} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <ClassList ref={classListRef} data={data} loadingData={loadingData} loginBranchInfo={loginBranchInfo} selectedBranch={selectedBranch} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { StatOldTomonote as default };
